import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const heroSlideAPI = axios.create({
  baseURL: `${API_BASE_URL}/hero-slide`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

heroSlideAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Hero Slide Service Error:', error);
    return Promise.reject(error);
  }
);

export const heroSlideService = {
  getSlides: async () => {
    try {
      const response = await heroSlideAPI.get('/public');
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener los slides del hero: ' + error.message);
    }
  },
};

export default heroSlideService;
